<template>
    <div class="p-3 customMaxWidth">
        <table v-if="pageLoader"></table>
        <div class="row">
            <div class="col-12 col-md-9">
                <div class="taskAndGoal">
                    <div class="carouselSlide position-relative">
                        <ul class="goalList d-flex align-items-center"><!--  style="overflow-x:auto; overflow-y: hidden;" -->
                            <li id="list1" :class="[{'active' : tab == 'steps'}]" @click="changeTab('steps')" v-show="showList.includes(1)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/step.svg" alt="Icon"></span>
                                    <p class="mb-1">Steps</p>
                                    <h4 class="mb-0">{{ initialData.steps._id ? initialData.steps.steps : 0 }}</h4>
                                </span>
                            </li>
                            <li id="list2" :class="[{'active' : tab == 'sleep'}]" @click="changeTab('sleep')" v-show="showList.includes(2)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/sleep.svg" alt="Icon"></span>
                                    <p class="mb-1">Sleep</p>
                                    <h4 class="mb-0">{{ initialData.sleep._id ? sleepTimeInHours(initialData.sleep.totalMinutesAsleep) : 0 }}</h4>
                                </span>
                            </li>
                            <li id="list3" :class="[{'active' : tab == 'heart'}]" @click="changeTab('heart')" v-show="showList.includes(3)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/energy.svg" alt="Icon"></span>
                                    <p class="mb-1">Heart Rate</p>
                                    <h4 class="mb-0">{{ initialData.heart._id ? initialData.heart.heartRate : 0 }}</h4>
                                </span>
                            </li>
                            <li id="list4" :class="[{'active' : tab == 'glucose'}]" @click="changeTab('glucose')" v-show="showList.includes(4)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/sugar-blood-level.svg" alt="Icon"></span>
                                    <p class="mb-1">Glucose Level</p>
                                    <h4 class="mb-0">{{ initialData.glucose._id ? initialData.glucose.value : 0 }}</h4>
                                </span>
                            </li>
                            <li id="list2" :class="[{'active' : tab == 'weight'}]" @click="changeTab('weight')" v-show="showList.includes(5)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/weight.svg" alt="Icon"></span>
                                    <p class="mb-1">Weight</p>
                                    <h4 class="mb-0">{{ initialData.weight._id ? getWeightLabel(initialData.weight) : 0 }}</h4>
                                </span>
                            </li>
                            <li id="list4" :class="[{'active' : tab == 'bp'}]" @click="changeTab('bp')" v-show="showList.includes(6)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/weight.svg" alt="Icon"></span>
                                    <p class="mb-1">Blood Pressure</p>
                                    <h4 class="mb-0">{{ initialData.bp._id ? `${initialData.bp.high}/${initialData.bp.low}` : `N/A` }}</h4>
                                </span>
                            </li>
                            <li id="list3" :class="[{'active' : tab == 'energy'}]" @click="changeTab('energy')" v-show="showList.includes(7)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/weight.svg" alt="Icon"></span>
                                    <p class="mb-1">Energy</p>
                                    <h4 class="mb-0">{{ initialData.energy._id ? initialData.energy.info : 0 }}</h4>
                                </span>
                            </li>
                            <li id="list1" :class="[{'active' : tab == 'mood'}]" @click="changeTab('mood')" v-show="showList.includes(8)">
                                <span class="oneList">
                                    <span class="goalImg"><img src="../../../../static/website/images/weight.svg" alt="Icon"></span>
                                    <p class="mb-1">Mood</p>
                                    <h4 class="mb-0">{{ initialData.mood._id ? getMoodLabel(initialData.mood.type) : 0 }}</h4>
                                </span>
                            </li>
                        </ul>
                        <div class="arrowSlide">
                            <a class="left" href="javascript:void(0)" @click="arrowFunc(0)" v-if="!showList.includes(1)"><feather type="arrow-left-circle"></feather></a>
                            <a class="right" href="javascript:void(0)" @click="arrowFunc(1)" v-if="!showList.includes(8)"><feather type="arrow-right-circle"></feather></a>
                        </div>
                    </div>
                    <div class="showModal">
                        <mood-form :form_type="(form_popup == 'mood')?1:(form_popup == 'energy')?2:null" v-if="form_popup == 'mood' || form_popup == 'energy'"></mood-form>
                    </div>
                    <div class="showTabList mt-3">
                        <div class="tabOne">
                            <div class="d-flex align-items-center justify-content-between">
                                <span>
                                    <h3 class="text-capitalize">{{tab}} History</h3>
                                    <!-- <ul class="tabList d-flex align-items-center">
                                        <li class="active"><a href="javascript:void(0)">Steps</a></li>
                                        <li><a href="javascript:void(0)">Distance</a></li>
                                        <li><a href="javascript:void(0)">Floors</a></li>
                                        <li><a href="javascript:void(0)">Calories burned</a></li>
                                    </ul> -->
                                </span>
                                <!-- <span class="dteAdd">
                                    <div class="form-group position-relative d-flex align-items-center dateArrow">
                                        <a href="javascript:void(0)"><feather type="chevron-left"></feather></a>
                                        <input type="date" class="float-field form-control mx-2" name="">
                                        <a href="javascript:void(0)"><feather type="chevron-right"></feather></a>
                                    </div>
                                </span> -->
                            </div>
                            <history-charts :chart_type="tab" v-if="tab"/>
                            <!-- <div class="stChart">
                                <img class="w-100" src="../../../../static/website/images/st-chart.svg" alt="Chart">
                            </div>
                            <div class="bottomValue d-flex align-items-center justify-content-between mt-3 pt-3 border-top">
                                <h4 class="mb-0">Yearly Total</h4>
                                <h3 class="mb-0">716,951<sub>steps</sub></h3>
                                <h3 class="mb-0">484.7<sub>km</sub></h3>
                                <h3 class="mb-0">590,684<sub>calories</sub></h3>
                            </div> -->
                        </div>
                    </div>
                </div>
                <!-- <div class="bg-white p-3 mt-4">
                    <h3 class="mb-3">Activity History</h3>
                    <div class="table-reponsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Date</th> 
                                    <th>Activity</th> 
                                    <th>Steps</th> 
                                    <th>Distance</th>
                                    <th>Duration</th>
                                    <th>Calories</th>
                                </tr>
                            </thead>
                             <tbody>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Walk</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Outdoor Bike</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Walk</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Outdoor Bike</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Walk</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Outdoor Bike</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Walk</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                                <tr>
                                    <td>02 Dec, 5:50PM</td>
                                    <td>Outdoor Bike</td>
                                    <td>2,101</td>
                                    <td>2.38 KM</td>
                                    <td>30 MIN</td>
                                    <td>95 Kcal</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> -->
            </div>
            <div class="col-12 col-md-3">
                <div class="bg-white text-center p-3">
                    <div class="d-flex align-items-center justify-content-between mb-4">
                        <h3>Tasks</h3>
                        <a href="javascript:void(0)"><feather type="plus-square"></feather></a>
                    </div>
                    <div class="p-detail-step">
                        <span class="goalImg"><img src="../../../../static/website/images/step.svg" alt="Icon"></span>
                        <p class="f-16"><strong>{{ initialData.steps._id ? initialData.steps.steps : 0 }}</strong> Steps taken</p>
                        <p>Because of insulin resistance, we are starting your plan with low carb but hight fat and protein diet.</p>
                        <span class="goalStep"><img src="../../../../static/website/images/woman_running.svg" alt="Icon"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import mood_form from "../user/forms/mood-form";
    import history_charts from "../history-data/charts";
    export default {
        name: "OVERALL-HEALTH-DATA",
        data() {
            return {
                pageLoader: false,
                tab : 'steps',
                form_popup: '',
                showList: [1,2,3,4,5]
            }
        },
        components: {
            moodForm: mood_form,
            historyCharts: history_charts
        },
        methods:{
            arrowFunc(type){
                if(type){
                    this.showList = this.showList.filter((val,index)=> index != 0)
                    this.showList.push(this.showList[3] + 1)
                }else{
                    this.showList = this.showList.filter((val,index)=> index != 4)
                    this.showList.unshift(this.showList[0] - 1)
                }
            },
            toggleForm(){
                this.form_popup = null
            },
            changeTab(tab){
                if(tab == 'mood' || tab == 'energy'){
                    this.form_popup = tab
                }else{
                    if(this.tab != tab){
                        this.tab = ''
                        setTimeout(()=>{
                           this.tab = tab 
                        },100);
                    }
                }
            },
            getChartData() {
                let input_json = {
                    'globalParams': {},
                    'localParams': { "parameter": this }
                }
                this._runGetChartData(input_json)
            },
        },
        created(){
            this.pageName('Overall Health Data')
            let input_json = {
                'globalParams': {},
                'localParams': { "parameter": this }
            }
            this.getChartData()
            this._runGetInitialData(input_json)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/overall-health/overall-health-data.vue